import { LanguageState } from '@app/core/language-service';
import { SeoState } from '@app/core/seo-service';
import { AccountState } from '@app/core/state/account';
import { AgreementsState } from '@app/core/state/agreements';
import { ChatState } from '@app/core/state/chat';
import { CountState } from '@app/core/state/count';
import { CurrencyState } from '@app/core/state/currency-store';
import { GameMessagesState } from '@app/core/state/game-messages';
import { CasesSharedState, GamesState, MediaPreferencesState } from '@app/core/state/games-store';
import { InventoryState } from '@app/core/state/inventory';
import { LastMethodsState } from '@app/core/state/last-methods';
import { LayoutState } from '@app/core/state/layout';
import { ModalsState } from '@app/core/state/modals';
import { NavigationState } from '@app/core/state/navigation';
import { NotificationsState } from '@app/core/state/notifications';
import { P2pBuyingState, P2pCommonState, P2pDepositState, P2pMarketState } from '@app/core/state/p2p';
import { PaymentState, RefillState, WithdrawalState } from '@app/core/state/payment-store';
import { RainState } from '@app/core/state/rain';
import { ReferralsState } from '@app/core/state/referrals';
import { SkinsState } from '@app/core/state/skins';
import { TicketsState } from '@app/core/state/tickets-store';
import { KYCState, UserState } from '@app/core/state/user-store';

export const STATES = [
  LanguageState,
  AccountState,
  NavigationState,
  AgreementsState,
  CasesSharedState,
  ChatState,
  CountState,
  CurrencyState,
  GamesState,
  InventoryState,
  KYCState,
  LayoutState,
  MediaPreferencesState,
  ModalsState,
  NotificationsState,
  P2pBuyingState,
  P2pCommonState,
  P2pDepositState,
  P2pMarketState,
  PaymentState,
  RainState,
  ReferralsState,
  RefillState,
  SeoState,
  SkinsState,
  UserState,
  WithdrawalState,
  TicketsState,
  LastMethodsState,
  GameMessagesState,
];
